import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import CallToAction from './CallToAction';

function Verified() {
  const { t } = useTranslation('translations');

  return (
    <Fragment>
      <header>
        <h1>{t('Confirmed!')}</h1>
      </header>
      <main>
        <p>{t('Your email address is confirmed successfully.')}</p>
        <p>{t('Please log in to the service.')}</p>
        <CallToAction action="/login">
          {t('Log In!')}
        </CallToAction>
      </main>
    </Fragment>
  );
}

export default Verified;
